export const MimeTypes = [
  'text/plain',
  'text/html',
  'text/markdown',
  'application/json',
  'image/png',
  'image/jpg',
  'image/jpeg',
];

export const TextMap = {
  'text/plain': true,
  'text/html': true,
  'text/markdown': true,
  'application/json': true,
};

export const ImageMap = {
  'image/jpg': true,
  'image/jpeg': true,
  'image/png': true,
};

export const ApplicationMap = {
  'application/json': true,
};
